var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGooglePinRecommended(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17,
    fill: "#FFD666",
    stroke: "#FAAD14",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 28.4166C18 28.4166 25 19.4493 25 15.5833C25 11.7173 21.866 8.58331 18 8.58331C14.134 8.58331 11 11.7173 11 15.5833C11 19.4493 18 28.4166 18 28.4166ZM18 17.9165C19.2887 17.9165 20.3333 16.8718 20.3333 15.5831C20.3333 14.2945 19.2887 13.2498 18 13.2498C16.7113 13.2498 15.6667 14.2945 15.6667 15.5831C15.6667 16.8718 16.7113 17.9165 18 17.9165Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePinRecommended);
export default __webpack_public_path__ + "static/media/google-pin-recommended.c8f5333c8d38c13e8dfde4e4494f0c44.svg";
export { ForwardRef as ReactComponent };